import {
  BookingData,
  BookingTool,
  Step,
} from "../../AppDataProvider/AppDataProvider";
import {
  ResourceAllocationType,
  ResourceSelectionMode,
} from "../../GeneratedGraphQL";
import { isFeatureFlagEnabledForOrganisation } from "..";
import { PartRequired } from "../types";
import { requireBookingDataFields } from "../requireBookingDataFields/requireBookingDataFields";

type GetDetailsPreviousStepOpts = {
  bookingData: BookingData;
  bookingTool: BookingTool;
};
type GetDetailsPreviousStepBookingData = PartRequired<
  BookingData,
  "organisation" | "service"
>;

export const getDetailsPreviousStep = ({
  bookingData,
  bookingTool,
}: GetDetailsPreviousStepOpts): Step => {
  requireBookingDataFields<GetDetailsPreviousStepBookingData>(bookingData, [
    "organisation",
    "service",
  ]);

  const { organisation, recurringBooking, service } = bookingData;
  const {
    allowBookingNotes,
    externalBookingQuestions,
    resourceSelectionBeforeAvailability,
  } = organisation;

  const hasRelevantBookingQuestions = externalBookingQuestions.some(
    (question) =>
      !question.services ||
      question.services.map(({ _id }) => _id).includes(service._id),
  );

  if (hasRelevantBookingQuestions || allowBookingNotes) {
    return "bookingQuestions";
  }

  if (bookingTool.organisationAvailabilityFlow) {
    return "locationAvailability";
  }

  /**
   * If we have been provided a resourceId in the url params,
   * we do not want to return to the resource step. We also do
   * not want to return to the resource step if there is only
   * one resource to choose from.
   */
  const urlParams = new URLSearchParams(window.location.search);
  const preFillResourceId = urlParams.get("resourceId");
  const availableResources = bookingData.resourceIds;

  if (
    bookingTool.resourceSelectionMode !== ResourceSelectionMode.Disabled &&
    service.resourceAllocationType === ResourceAllocationType.Any &&
    !resourceSelectionBeforeAvailability &&
    !preFillResourceId &&
    availableResources &&
    availableResources.length > 1
  ) {
    return "resources";
  }

  if (recurringBooking) return "recurringBooking";

  return "availability";
};
